import React from "react"
import { StyleSheet, View } from "react-native"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"

const getNextSteps = (studentFirstname) => [
    {
        icon: "calendar",
        label: "Choix des horaires",
        subtitle:
            "Vous choisissez les créneaux possibles pour les cours réguliers",
    },
    {
        icon: "user-check",
        label: "Attribution du tuteur (48h)",
        subtitle: "On vous propose un tuteur et des horaires de cours sous 48h",
    },
    {
        icon: "rocket",
        label: "Démarrage",
        subtitle: `${studentFirstname || "Votre enfant"} démarre son accompagnement Masteur !`,
    },
]

export const NewSubscriptionNextStepsCard = ({ studentFirstname }) => {
    const nextSteps = getNextSteps(studentFirstname)
    return (
        <View style={styles.card}>
            <TextM
                fontWeight="bold"
                fontSize={18}
                color={theme.colors.black}
                wrap
            >
                Prochaines étapes après le paiement
            </TextM>
            <View style={{ gap: 40, position: "relative" }}>
                <View style={styles.line} />
                {nextSteps.map((step, i) => (
                    <View style={[styles.row, { gap: 16 }]} key={i}>
                        <View style={styles.stepCount}>
                            <TextM fontWeight="Bold" color={theme.colors.white}>
                                {i + 1}
                            </TextM>
                        </View>
                        <View style={{ gap: 5, flex: 1 }}>
                            <View
                                style={[
                                    styles.row,
                                    { justifyContent: "flex-start" },
                                ]}
                            >
                                <FontAwesome5
                                    name={step.icon}
                                    color={theme.colors.accent}
                                    size={16}
                                />
                                <TextM fontWeight="Bold" wrap>
                                    {step.label}
                                </TextM>
                            </View>
                            <TextM
                                color={theme.colors.light}
                                fontWeight="Medium"
                                wrap
                            >
                                {step.subtitle}
                            </TextM>
                        </View>
                    </View>
                ))}
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    card: {
        padding: 20,
        borderRadius: 20,
        gap: 15,
        borderWidth: 1,
        borderColor: theme.colors.lightMore,
    },
    line: {
        position: "absolute",
        top: 0,
        left: 20,
        height: "100%",
        width: 1,
        backgroundColor: theme.colors.lightMore,
    },
    row: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 10,
        flexWrap: "wrap",
    },
    stepCount: {
        width: 40,
        height: 40,
        borderRadius: 100,
        backgroundColor: theme.colors.primary,
        justifyContent: "center",
        alignItems: "center",
    },
})
